webpackJsonp([212839066777427],{

/***/ 76:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Index;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(68);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _navbar = __webpack_require__(19);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _mobileContent = __webpack_require__(23);
	
	var _mobileContent2 = _interopRequireDefault(_mobileContent);
	
	var _formsShared = __webpack_require__(44);
	
	var _shibui = __webpack_require__(15);
	
	var _sharedStyles = __webpack_require__(63);
	
	var _sharedStyles2 = _interopRequireDefault(_sharedStyles);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var S = _extends({
	  blogHeaderWrap: _extends({}, _sharedStyles2.default.flexCenter, {
	    textAlign: 'center',
	    width: '100%',
	    marginTop: _shibui.spacing.lg
	  }),
	  flexContentWrap: {
	    display: 'flex',
	    justifyContent: 'center',
	    marginBottom: 50
	  },
	  postsContentWrap: {
	    width: '100%',
	    maxWidth: _shibui.sizing.xxl,
	    height: '100%',
	    paddingLeft: 20,
	    paddingRight: 20,
	    '@media screen and (maxWidth: 1115px)': {
	      width: '90%',
	      paddingLeft: 10,
	      paddingRight: 10
	    }
	  },
	  flexGrid: {
	    display: 'flex',
	    justifyContent: 'space-between',
	    alignContent: 'flex-start',
	    flexWrap: 'wrap',
	    '@media screen and (maxWidth: 1115px)': {
	      display: 'block'
	    }
	  },
	  flexGridImage: {
	    position: 'relative',
	    float: 'left',
	    width: '34%',
	    height: '100%'
	  },
	  flexGridContent: {
	    padding: '0px 40px 12px 40px',
	    position: 'relative',
	    float: 'left',
	    width: '66%'
	  },
	  date: {
	    marginTop: -_shibui.spacing.sm,
	    marginBottom: _shibui.spacing.sm,
	    fontSize: 12,
	    color: _shibui.colors.graphite.color
	  },
	  hideOnMobile: {
	    '@media screen and (maxWidth: 700px)': {
	      display: 'none'
	    }
	  },
	  tag: {
	    fontSize: 12,
	    background: _shibui.colors.amethyst50.color,
	    color: _shibui.colors.ivory.color,
	    borderRadius: 4,
	    padding: _shibui.spacing.xs + 'px ' + _shibui.spacing.sm + 'px',
	    display: 'inline-block',
	    marginTop: 8
	  }
	}, _formsShared.FORM_STYLES);
	
	function Index(_ref) {
	  var data = _ref.data;
	  var posts = data.allMarkdownRemark.edges;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Blog | Haiku'
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: 'Thoughts on collaboration, design, and shipping software' }),
	      _react2.default.createElement('meta', { property: 'og:title', content: 'Blog | Haiku' }),
	      _react2.default.createElement('meta', { property: 'og:description', content: 'Thoughts on collaboration, design, and shipping software' })
	    ),
	    _react2.default.createElement(_navbar2.default, { location: 'blog' }),
	    _react2.default.createElement(
	      'div',
	      { style: {
	          margin: '0 auto'
	        } },
	      _react2.default.createElement(
	        'div',
	        { style: S.blogHeaderWrap },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/blog/' },
	          _react2.default.createElement(
	            'h1',
	            { style: _extends({}, _shibui.typography.heading1, _sharedStyles2.default.centerer, { margin: _shibui.spacing.sm + 'px 0 0', color: _shibui.colors.midnight.color }) },
	            'Haiku Blog'
	          ),
	          _react2.default.createElement(
	            'p',
	            { style: _sharedStyles2.default.subtitle },
	            'Articles, videos and resources by the Haiku team.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: S.flexContentWrap },
	        _react2.default.createElement(
	          'div',
	          { style: S.postsContentWrap },
	          _react2.default.createElement(
	            'div',
	            { style: S.flexGrid },
	            posts.filter(function (post) {
	              return post.node.frontmatter.title.length > 0;
	            }).map(function (_ref2, index) {
	              var post = _ref2.node;
	
	              return _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: post.frontmatter.path, tabIndex: index + 10, className: 'flexGridBlog', key: post.id },
	                _react2.default.createElement(
	                  'div',
	                  { style: S.flexGridImage },
	                  post.frontmatter.coverImage && _react2.default.createElement('img', { className: 'blogFeatureImage', src: post.frontmatter.coverImage.publicURL, alt: post.frontmatter.title })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: S.flexGridContent },
	                  _react2.default.createElement(
	                    'h3',
	                    { style: _extends({}, _shibui.typography.heading3, { color: _shibui.colors.midnight.color }) },
	                    post.frontmatter.title
	                  ),
	                  _react2.default.createElement(
	                    'h4',
	                    { style: S.date },
	                    post.frontmatter.date
	                  ),
	                  post.frontmatter.tags && post.frontmatter.tags.map(function (tag, index) {
	                    return _react2.default.createElement(
	                      'span',
	                      { key: 'tag' + index, style: S.tag },
	                      tag
	                    );
	                  }),
	                  _react2.default.createElement(
	                    'p',
	                    { style: _sharedStyles2.default.subtitle },
	                    post.excerpt
	                  )
	                )
	              );
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_mobileContent2.default, null)
	  );
	}
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-21051dd6ab47bd277f26.js